import React from 'react'

export default function HeroImage() {
  return (
    <div className='flex-center'>
      <img src="./images/Santosh.jpg" alt="Santosh" className='profile-image' />
    </div>
  )
}
